import dayjs from 'dayjs';

const isToday = (date) => {
    const today = new Date();
    return (
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
    );
};

export const formatDateMoment = (date) => {
    const today = dayjs();
    const inputDate = dayjs(date);
    if (inputDate.isSame(today, 'day')) {
        return 'Hoje';
    } else if (inputDate.isSame(today.subtract(1, 'day'), 'day')) {
        return 'Ontem';
    } else {
        return inputDate.format('DD/MM/YYYY');
    }
};

export const formatDateTimeMoment = (date) => {
    return dayjs(date).format('DD/MM/YY - HH:mm:ss');
};

export const getHoursAndMinutes = (date) => {
    return dayjs(date).format('HH:mm');
};

export const getRequestDate = (date) => {
    return dayjs(date).format('YYYY-MM-DD');
};

const DateUtils = {
    isToday
};

export const getLastYearDate = (years) => {
    return dayjs().subtract(years, 'year');
};

export default DateUtils;
